// import React from 'react'
import excel from '../excel';
import { formatNames } from '../../utils/formatNames';

export const RequirementReport = ({ requirement, showAlert, currentUser }) => {
    try {

        if (!requirement || requirement.length === 0) {
            console.log("Data ")
            showAlert?.("No EOD data available.");
            return;
        }
        const rows = requirement.map(d => ({
            "Team Manager": (d?.reportingManager?.name) ? formatNames(d?.reportingManager?.name) : "-",
            "Team Lead": (d?.reportingTeamLead?.name) ? formatNames(d?.reportingTeamLead?.name) : "-",
            "Submitted By": (d?.submittedBy?.name) ? formatNames(d?.profileSubmittedBy?.name) : "-",
            "Updated By": (d?.submittedBy?.name) ? formatNames(d?.submittedBy?.name) : "-",
            "SAN SPOC": (d?.primaryRecruiter?.name) ? formatNames(d?.primaryRecruiter?.name) : "-",
            "Client Name": (d?.client?.name) ? formatNames(d?.client?.name) : "-",
            "Client Manager": (d?.spoc?.name) ? formatNames(d?.spoc?.name) : "-",
            "Job Applied": d?.job?.title ?? "-",
            "Applicant Name": (d?.candidate?.name) ? formatNames(d?.candidate?.name) : "-",
            "Mobile Number": d?.candidate?.number ?? "-",
            "Email Address": d?.candidate?.email ?? "-",
            "Submitted On": d?.profileSubmittedOn ? new Date(d?.profileSubmittedOn).toLocaleString("en-GB") : "-",
            "Status Changed On": d?.recentStatus?.timestamp ? new Date(d?.recentStatus?.timestamp).toLocaleString("en-GB") : "-",
            "Profile Recent Status": (d?.recentStatus?.status) ? formatNames(d?.recentStatus?.status) : "-",
            "Current CTC": d?.currentCTC?.amount ?? "-",
            "Expected CTC": d?.expectedCTC?.amount ?? "-",
            "Offered CTC": d?.recentStatus?.offeredCtc ?? "-",
            "Job Status": (d?.job?.status) ? formatNames(d?.job?.status) : "-",
            "Remarks": d?.recentStatus?.comment ?? "-",
            "Job Subcategory": d?.recentStatus?.subcategory ?? "-",
            "Interview Scheduled Date": d?.recentStatus?.scheduledDate ? new Date(d?.recentStatus?.scheduledDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            }) : "-",
            "Date of Joining": d?.recentStatus?.doj ? new Date(d?.recentStatus?.doj).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            }) : "-",
            "Employee Id": d?.recentStatus?.empId ?? "-"

        }));

        excel({ rows, showAlert, type: "recruitment report", currentUser })

        showAlert?.("Excel downloaded successfully.");
    }
    catch (err) {
        console.error("Error in Recruitment Report:", err);
        showAlert?.("Error while generating Excel.");
    }
}
